<template>
  <div>
    <vs-button color="success" @click="geoFindMe" type="filled"
      >Success</vs-button
    >
    <p id="status"></p>
    <p id="map-link"></p>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    geoFindMe() {
      const status = document.querySelector("#status");
      const mapLink = document.querySelector("#map-link");

      mapLink.href = "";
      mapLink.textContent = "";

      function success(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        console.log(latitude, longitude);
        status.textContent = "";
        mapLink.href = `https://www.openstreetmap.org/#map=18/${latitude}/${longitude}`;
        mapLink.textContent = `Latitude: ${latitude} °, Longitude: ${longitude} °`;
        var latlng = new google.maps.LatLng(latitude, longitude);
        // This is making the Geocode request
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ latLng: latlng }, (results, status) => {
          if (status !== google.maps.GeocoderStatus.OK) {
            alert(status);
          }
          // This is checking to see if the Geoeode Status is OK before proceeding
          if (status == google.maps.GeocoderStatus.OK) {
            console.log(results);
            var address = results[0].formatted_address;
          }
        });
      }

      function error() {
        status.textContent = "Unable to retrieve your location";
      }

      if (!navigator.geolocation) {
        status.textContent = "Geolocation is not supported by your browser";
      } else {
        status.textContent = "Locating…";
        navigator.geolocation.getCurrentPosition(success, error);
      }
    },
    getReverseGeocodingData(lat, lng) {
      var latlng = new google.maps.LatLng(lat, lng);
      // This is making the Geocode request
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ latLng: latlng }, (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK) {
          alert(status);
        }
        // This is checking to see if the Geoeode Status is OK before proceeding
        if (status == google.maps.GeocoderStatus.OK) {
          console.log(results);
          var address = results[0].formatted_address;
        }
      });
    },
  },
  mounted() {
    // document.querySelector("#find-me").addEventListener("click", geoFindMe);
  },
};
</script>
